<!-- Barra di caricamento -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Menu laterale compatto: icone grandi con il nome sotto, i sottomenu si aprono in un pannello laterale -->
<fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [appearance]="'compact'"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.compact"
    [opened]="!isScreenSmall">
    <ng-container fuseVerticalNavigationContentHeader>
        <a [routerLink]="'/dashboard'" class="flex items-center justify-center mt-4 mb-3 mx-3 rounded-xl bg-white p-2" title="StayInPuglia">
            <img class="w-full" src="assets/images/logo/logo.png" alt="StayInPuglia">
        </a>
    </ng-container>
</fuse-vertical-navigation>

<!-- Contenitore -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Barra superiore -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <a mat-stroked-button [href]="publicSiteUrl" target="_blank" class="hidden sm:inline-flex">
                <mat-icon class="icon-size-5 mr-1" [svgIcon]="'heroicons_outline:arrow-top-right-on-square'"></mat-icon>
                Vai al sito
            </a>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <user></user>
        </div>
    </div>

    <!-- Contenuto a tutta larghezza -->
    <div class="flex flex-col flex-auto">
        <router-outlet *ngIf="true"></router-outlet>
    </div>

</div>
